module.exports = __webpack_public_path__ + "img/KCC-active.078d576d.png";